//Get all notification
const NOTIFICATION_DATA = {
  NOTIFICATION_DATA_LOAD: "NOTIFICATION_DATA_LOAD",
  NOTIFICATION_DATA_SUCCESS: "NOTIFICATION_DATA_SUCCESS",
  NOTIFICATION_DATA_FAIL: "NOTIFICATION_DATA_FAIL",
};
const NOTIFICATION_DATA_GET_API = "/notification/all_notification";

//Get notification by id
const NOTIFICATION_GET_DATA = {
  NOTIFICATION_GET_DATA_LOAD: "NOTIFICATION_GET_DATA_LOAD",
  NOTIFICATION_GET_DATA_SUCCESS: "NOTIFICATION_GET_DATA_SUCCESS",
  NOTIFICATION_GET_DATA_FAIL: "NOTIFICATION_GET_DATA_FAIL",
};
const NOTIFICATION_GET_DETAIL_API = "/notification/getByID/";

// get by id audit data
const NOTIFICATION_AUDIT_GET_DATA = {
  NOTIFICATION_AUDIT_GET_DATA_LOAD: "NOTIFICATION_AUDIT_GET_DATA_LOAD",
  NOTIFICATION_AUDIT_GET_DATA_SUCCESS: "NOTIFICATION_AUDIT_GET_DATA_SUCCESS",
  NOTIFICATION_AUDIT_GET_DATA_FAIL: "NOTIFICATION_AUDIT_GET_DATA_FAIL",
};
const NOTIFICATION_AUDIT_GET_API = "/notification/audit/";

// Add Noti
const NOTIFICATION_FORM_ADD_DATA = {
  NOTIFICATION_FORM_ADD_DATA_LOAD: "NOTIFICATION_FORM_ADD_DATA_LOAD",
  NOTIFICATION_FORM_ADD_DATA_SUCCESS: "NOTIFICATION_FORM_ADD_DATA_SUCCESS",
  NOTIFICATION_FORM_ADD_DATA_FAIL: "NOTIFICATION_FORM_ADD_DATA_FAIL",
};
const NOTIFICATION_FORM_POST_API = "/notification/add";

// Update / Put
const NOTIFICATION_UPDATE_DATA = {
  NOTIFICATION_UPDATE_DATA_LOAD: "NOTIFICATION_UPDATE_DATA_LOAD",
  NOTIFICATION_UPDATE_DATA_SUCCESS: "NOTIFICATION_UPDATE_DATA_SUCCESS",
  NOTIFICATION_UPDATE_DATA_FAIL: "NOTIFICATION_UPDATE_DATA_FAIL",
};

const NOTIFICATION_POST_API = "/notification/edit";

// Delete Noti
const NOTIFICATION_DELETE_DATA = {
  NOTIFICATION_DELETE_LOAD: "NOTIFICATION_DELETE_LOAD",
  NOTIFICATION_DELETE_SUCCESS: "NOTIFICATION_DELETE_SUCCESS",
  NOTIFICATION_DELETE_FAIL: "NOTIFICATION_DELETE_FAIL",
};
const NOTIFICATION_DELETE_API = "/notification/delete/";



export{
  
  NOTIFICATION_DATA,
  NOTIFICATION_DATA_GET_API,
  NOTIFICATION_GET_DATA,
  NOTIFICATION_GET_DETAIL_API,
  NOTIFICATION_FORM_ADD_DATA,
  NOTIFICATION_FORM_POST_API,
  NOTIFICATION_UPDATE_DATA,
  NOTIFICATION_POST_API, 
  NOTIFICATION_DELETE_DATA,
  NOTIFICATION_DELETE_API,  
  NOTIFICATION_AUDIT_GET_DATA,
  NOTIFICATION_AUDIT_GET_API,

}